import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Search, ShoppingCart, Menu, X } from "lucide-react";
import Container from "./container";

export default function Navbar({}) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);

  const handleCartUpdate = () => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    const count = cart.reduce((acc, item) => acc + item.quantity, 0);
    setCartCount(count);
  };

  useEffect(() => {
    handleCartUpdate();
    window.addEventListener("cartUpdated", handleCartUpdate);
    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdate);
    };
  }, []);

  const links = [
    { label: "Shop", to: "/products" },
    // { label: "Categories", to: "/categories" },
    { label: "About", to: "/about-us" },
  ];

  return (
    <header className="sticky top-0 z-50 border-b border-black/10 bg-[#fbf7f1]/80 backdrop-blur">
      <Container>
        <div className="flex h-16 items-center justify-between">
          {/* Brand */}
          <Link to="/" className="flex items-center gap-3">
            {/* <div className="grid h-9 w-9 place-items-center rounded-xl border border-black/10 bg-white shadow-sm">
              <span className="text-sm font-black tracking-tight">R</span>
            </div>
            <div className="leading-tight">
              <div className="text-sm font-extrabold tracking-tight">
                Retro Revive
              </div>
              <div className="text-[11px] font-semibold text-black/45">
                Vintage collectibles
              </div>
            </div> */}

            <img
              src="/logo.png"
              alt="Retro Revive Logo"
              className="h-9 w-18 rounded-xl border border-black/10 bg-white shadow-sm"
            />
          </Link>

          {/* Desktop nav */}
          <nav className="hidden items-center gap-8 md:flex">
            {links.map((l) => (
              <NavLink
                key={l.label}
                to={l.to}
                className={({ isActive }) =>
                  `text-sm font-semibold transition ${
                    isActive ? "text-black" : "text-black/65 hover:text-black"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          {/* Actions */}
          <div className="flex items-center gap-2">
            <Link
              to="/cart"
              className="relative rounded-xl border border-black/10 bg-white p-2 shadow-sm transition hover:bg-black/5"
            >
              <ShoppingCart className="h-5 w-5 text-black/70" />
              <span className="absolute -right-1 -top-1 grid h-5 w-5 place-items-center rounded-full bg-orange-600 text-[11px] font-extrabold text-white">
                {cartCount}
              </span>
            </Link>

            <button
              className="ml-1 inline-flex rounded-xl border border-black/10 bg-white p-2 shadow-sm transition hover:bg-black/5 md:hidden"
              onClick={() => setMobileOpen((s) => !s)}
              aria-label="Toggle menu"
            >
              {mobileOpen ? (
                <X className="h-5 w-5 text-black/70" />
              ) : (
                <Menu className="h-5 w-5 text-black/70" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile dropdown */}
        {mobileOpen && (
          <div className="pb-4 md:hidden">
            <div className="flex items-center gap-2 pb-3">
              <div className="relative w-full">
                <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-black/40" />
                <input
                  placeholder="Search products..."
                  className="w-full rounded-xl border border-black/10 bg-white py-2 pl-9 pr-3 text-sm outline-none focus:ring-2 focus:ring-orange-600/30"
                />
              </div>
            </div>

            <div className="grid gap-2">
              {links.map((l) => (
                <NavLink
                  key={l.label}
                  to={l.to}
                  onClick={() => setMobileOpen(false)}
                  className="rounded-xl border border-black/10 bg-white px-4 py-3 text-sm font-semibold text-black/70 shadow-sm"
                >
                  {l.label}
                </NavLink>
              ))}
            </div>
          </div>
        )}
      </Container>
    </header>
  );
}
